"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M443.5 235.3L318.8 110.6c-8.1-8.1-21.3-8.1-29.5 0-8.1 8.1-8.1 21.3 0 29.5l89.1 89.1h-316c-11.5 0-20.8 9.3-20.8 20.8s9.3 20.8 20.8 20.8h315.8L288.5 360c-8.2 8.1-8.2 21.3-.1 29.5 4.1 4.1 9.4 6.1 14.8 6.1 5.3 0 10.6-2 14.7-6.1l125.6-124.8c3.9-3.9 6.1-9.2 6.1-14.7s-2.2-10.8-6.1-14.7z"
  });
};

exports.default = _default;